import axios from "axios";
import deffDB from "./deff_db.json";
import { mensagemErro } from "../library";

let baseURL = "";

if (deffDB?.baseURL) 
    baseURL += deffDB?.baseURL;
else {
    if (deffDB?.baseURLProcotol) 
        baseURL += deffDB?.baseURLProcotol + "://";

    baseURL += window.location.hostname;

    if (deffDB?.baseURLPort)
        baseURL += ":" + deffDB?.baseURLPort;
}

export default axios.create({
    baseURL: baseURL,
    timeout: 20000,
    headers: {
        "Content-Type": "application/x-www-form-urlencoded"
    }
});

export function MENSAGEM_ERRO_HTTP(erro, funcaoOK = null) {
    mensagemErro("Não foi possível conectar com o servidor.", erro ? erro : " ", true, funcaoOK ? funcaoOK : null);
}
